import css from 'styled-jsx/css';

const styles = css.global`  #perguntas .perguntas-contain {
    margin-top: 48px;
    margin-bottom: 80px;
  }
  
  #perguntas .group-perguntas {
    margin-top: 24px;
  }
  
  #perguntas .custom-accordion .acc-header .acc-title {
    font-family: "SantanderText";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #444;
    margin-right: 8px;
  }
  
  #perguntas .custom-accordion .acc-header,
  #perguntas .custom-accordion .acc-body {
    padding: 0 0 16px;
  }
  
  #perguntas .custom-accordion.mb-space {
    margin-bottom: 40px;
  }
  
  #perguntas .custom-accordion.opened .acc-header {
    background-color: #ffffff;
  }
  
  #perguntas .custom-accordion .acc-body.default p {
    font-family: "SantanderText";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #444;
    max-width: calc(100% - 25px);
    animation: openAcc .3s forwards;
  }

  #perguntas .custom-accordion .acc-body.default p a {
    font-family: "SantanderText";
    font-style: normal;
    font-weight: 400;
    color: #C00;
  }

  #perguntas .custom-accordion .acc-body.default p a:hover {
    text-decoration: underline;
  }
  
  
  @keyframes openAcc {
    from {
      height: 0px;
      visibility: hidden;
      opacity: 0;
      /* padding: 0px 16px; */
    }

    to {
      height: auto;
      visibility: visible;
      opacity: 1;
      /* padding: 16px 16px; */
    }
  }
  
  @media (min-width: 992px) {
    #perguntas .perguntas-contain {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 24px;
    }
  
    #perguntas .group-perguntas {
      margin-top: 0;
      margin-left: 48px;
      width: 100%;
    }
  
    #perguntas .group-perguntas .title-perguntas {
      text-align: left;
      line-height: 36px;
      margin-bottom: 40px;
    }
  
    #perguntas .custom-accordion .acc-header {
      padding: 0 16px 16px 0;
      min-height: auto;
    }
    #perguntas .custom-accordion .acc-body {
      padding: 0;
    }
  
    #perguntas .custom-accordion .acc-body.default p {
      animation: openAcc .3s forwards;
    }
    @keyframes openAcc {
      from {
        height: 0px;
        visibility: hidden;
        opacity: 0;
        padding: 0px 16px;
      }

      to {
        height: auto;
        visibility: visible;
        opacity: 1;
        padding: 16px 16px;
      }
    }
  }`;

export default styles;